var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 13,
    fill: "none",
    viewBox: "0 0 9 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C1F3B",
    d: "M.66 10.63a1 1 0 0 0 1.279 1.536l5.994-5a1 1 0 0 0 0-1.537l-5.994-5a1 1 0 0 0-1.28 1.536l5.074 4.232z"
  })));
};
export default SvgChevronRight;